// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InStackDemandOtherSelector {
  display: flex;
  flex-wrap: wrap;
  grid-gap: 5px;
  margin-top: 36px;
}

.InStackDemandOtherSelector .InStackDemandItem,
.InStackDemandOtherSelector .InStackDemandItem:not(.ant-tag-checkable-checked):hover,
.InStackDemandOtherSelector .InStackDemandItem:not(.ant-tag-checkable-checked):active {
  background: #4444440F 0% 0% no-repeat padding-box;
  color: #444444;
  padding-top: 7px;
  padding-bottom: 6px;
  border-color: transparent;
  padding-left: 12px;
  border-radius: 50px;
  padding-right: 12px;
  position: relative;
  opacity: 1 !important;
  margin-right: 0;
}

.InStackDemandItem.ant-tag-checkable-checked{
  background: 0% 0% no-repeat padding-box padding-box rgb(102, 102, 102);
  color: rgb(255, 255, 255);
}

.InStackDemandItemPopupList {
  position: absolute;
  left: 0;
  top: 100%;
  min-width: 182px;
  padding: 15px;
  padding-right: 26px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0 8px 16px #00000014;
  border-radius: 4px;
  z-index: 1;
  color: #212121;
}

.InStackDemandItemSkillItem {
  font-size: 16px;
  padding: 13px;
  position: relative;
}

.InStackDemandItemSkillItem.checked{
  font-weight: 600;
}

.InStackDemandItemSkillItem img{
  visibility: hidden;
}

.InStackDemandItemSkillItem.checked img{
  visibility: visible;
}

.InStackDemandItemSkillItem img{
  position: absolute;
  right: -10px;
}

.InStackDemandItemPopupList-title{
  color:#56A8F7;
  text-transform: capitalize;
  font-size: 12px;
  padding: 13px;
  display: flex;
  flex-direction: column;
}

.InStackDemandItemPopupList-title small {
  font-size: 9px;
}

.njobs {
  background: #e6e5e5;
  color:#666666;
  margin-left: 12px;
  font-size: 10px;
  padding: 0;
  border-radius: 10px;
  min-width: 50px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.ant-tag-checkable-checked .njobs {
  background: #4c4c4c;
  color: #d8d8d8;
}`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/shared/InStackDemandOtherSelector/InStackDemandOtherSelector.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;EAGE,iDAAiD;EACjD,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,sEAAsE;EACtE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,+CAA+C;EAC/C,gCAAgC;EAChC,kBAAkB;EAClB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":[".InStackDemandOtherSelector {\n  display: flex;\n  flex-wrap: wrap;\n  grid-gap: 5px;\n  margin-top: 36px;\n}\n\n.InStackDemandOtherSelector .InStackDemandItem,\n.InStackDemandOtherSelector .InStackDemandItem:not(.ant-tag-checkable-checked):hover,\n.InStackDemandOtherSelector .InStackDemandItem:not(.ant-tag-checkable-checked):active {\n  background: #4444440F 0% 0% no-repeat padding-box;\n  color: #444444;\n  padding-top: 7px;\n  padding-bottom: 6px;\n  border-color: transparent;\n  padding-left: 12px;\n  border-radius: 50px;\n  padding-right: 12px;\n  position: relative;\n  opacity: 1 !important;\n  margin-right: 0;\n}\n\n.InStackDemandItem.ant-tag-checkable-checked{\n  background: 0% 0% no-repeat padding-box padding-box rgb(102, 102, 102);\n  color: rgb(255, 255, 255);\n}\n\n.InStackDemandItemPopupList {\n  position: absolute;\n  left: 0;\n  top: 100%;\n  min-width: 182px;\n  padding: 15px;\n  padding-right: 26px;\n  background: #FFFFFF 0% 0% no-repeat padding-box;\n  box-shadow: 0 8px 16px #00000014;\n  border-radius: 4px;\n  z-index: 1;\n  color: #212121;\n}\n\n.InStackDemandItemSkillItem {\n  font-size: 16px;\n  padding: 13px;\n  position: relative;\n}\n\n.InStackDemandItemSkillItem.checked{\n  font-weight: 600;\n}\n\n.InStackDemandItemSkillItem img{\n  visibility: hidden;\n}\n\n.InStackDemandItemSkillItem.checked img{\n  visibility: visible;\n}\n\n.InStackDemandItemSkillItem img{\n  position: absolute;\n  right: -10px;\n}\n\n.InStackDemandItemPopupList-title{\n  color:#56A8F7;\n  text-transform: capitalize;\n  font-size: 12px;\n  padding: 13px;\n  display: flex;\n  flex-direction: column;\n}\n\n.InStackDemandItemPopupList-title small {\n  font-size: 9px;\n}\n\n.njobs {\n  background: #e6e5e5;\n  color:#666666;\n  margin-left: 12px;\n  font-size: 10px;\n  padding: 0;\n  border-radius: 10px;\n  min-width: 50px;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.ant-tag-checkable-checked .njobs {\n  background: #4c4c4c;\n  color: #d8d8d8;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
